import { getSelectedCategory } from "app/pages/industry-analysis/common/getSelectedCategory";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { PdfExportService, REPORT_LINK_KEY } from "app/services/PdfExportService";
import DurationService from "app/services/DurationService";

export const onPdfDownload = (): Promise<unknown> => {
    const category = getSelectedCategory();
    const params = proNavigator.getParams();
    const { duration } = params ?? {};
    const durationObj = DurationService.getDurationData(duration);
    const date = Array.isArray(durationObj.forWidget) ? durationObj.forWidget.toString() : durationObj.forWidget;
    const options = { date };
    if (!category) {
        return null;
    }
    const { text } = category;
    return PdfExportService.downloadPdfFedService(REPORT_LINK_KEY, text, options);
};
